import React, { useMemo } from 'react';
import { Box, FormGroup, IconButton, InputAdornment } from '@mui/material';
import { CheckboxUI, DebouncedInputUI, FormLabelUI, InputUI } from '../../../Interface';
import ClearIcon from '@mui/icons-material/Clear';
import useUsers from '../../../../context/UsersContext';
import useSaveView from '../../../../hooks/useSaveView';

const GanttFilter = ({ initial, searchQuery, onSearchChange, options }) => {
  const { user } = useUsers();
  const saveView = useSaveView(user);
  const { initialState, setInitialState } = initial;

  const handleFilterChange = (field, value, id = null, operator) => {
    setInitialState((prev) => {
      let newItems = prev.filter.filterModel.items.filter((item) => item.field !== field);

      if (value !== null && value !== '') {
        newItems.push({
          id,
          field,
          operator: operator ?? 'is',
          value,
        });
      }

      return {
        ...prev,
        filter: {
          filterModel: {
            items: newItems,
            logicOperator: 'and',
          },
        },
      };
    });
  };

  const toggleType = (id) => {
    const item = initialState?.filter?.filterModel?.items?.find((i) => i.field === 'projectTypeId');

    const current = Array.isArray(item?.value) ? item.value : [];

    const next = current.includes(id) ? current.filter((x) => x !== id) : [...current, id];

    handleFilterChange('projectTypeId', next, null, 'isAnyOf');
    saveView('projectTaskFilter', { projectTypeId: next });
  };

  return (
    <FormGroup>
      <Box display="flex" alignItems="center" gap="0.5rem" flexWrap="wrap">
        <Box>
          <InputUI
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Feladat keresés…"
            size="small"
            variant="outlined"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {!!searchQuery && (
                    <IconButton
                      aria-label="Keresés törlése"
                      size="small"
                      edge="end"
                      onClick={() => onSearchChange('')}
                      tabIndex={-1}
                    >
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  )}
                </InputAdornment>
              ),
            }}
          />
        </Box>

        <Box>
          <DebouncedInputUI
            size="small"
            placeholder="Projekt keresés…"
            debounceMs={800}
            variant="outlined"
            setQuickFilterSearchValue={(newValue) => {
              handleFilterChange('projectName', newValue, null, 'contains');
            }}
            quickFilterSearchValue={
              initialState?.filter?.filterModel?.items?.find((i) => i.field === 'projectName')?.value
            }
          />
        </Box>

        <Box display="flex" alignItems="center" gap="0.75rem" flexWrap="wrap">
          {options?.types?.map((option) => (
            <CheckboxUI
              key={option.value}
              label={<FormLabelUI text={option.label} />}
              checked={initialState?.filter?.filterModel?.items
                ?.find((i) => i.field === 'projectTypeId')
                ?.value?.includes(option.value)}
              onChange={() => toggleType(option.value)}
            />
          ))}
        </Box>
      </Box>
    </FormGroup>
  );
};

export default GanttFilter;
